module.exports = __webpack_public_path__ + "static/media/logoSER.71b22975.webp";